import { render, staticRenderFns } from "./projedit.vue?vue&type=template&id=1f287252&scoped=true"
import script from "./projedit.vue?vue&type=script&lang=js"
export * from "./projedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f287252",
  null
  
)

export default component.exports